import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Tariful orar al unui tehnician (`user`) sau grup (`group`) - CEC #3, costul
 * pe tehnician din rapoarte. `TechnicianRatesController`:
 *
 *   GET /settings/rates/{type}/{id}
 *   PUT /settings/rates/{type}/{id}   {hourly_rate: number | null, currency}
 */

export type RateSubject = 'user' | 'group'

export interface HourlyRate {
  hourly_rate: number | null
  currency: string
  may_edit: boolean
}

export function hourlyRateQuery(type: RateSubject, id: number) {
  return queryOptions({
    queryKey: ['settings', 'rates', type, id],
    queryFn: () => apiGet<HourlyRate>(`/settings/rates/${type}/${id}`),
    retry: false,
  })
}

export function saveHourlyRate(type: RateSubject, id: number, rate: number | null, currency: string): Promise<HourlyRate> {
  return apiGet<HourlyRate>(`/settings/rates/${type}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ hourly_rate: rate, currency }),
  })
}
